import {
  SmartSearchEntityType,
  SmartSearchTabs,
  SmartSearchTabsType,
} from '../../SmartSearch.types.js'

export const isValidDateParam = (
  dateStr: string,
  relativeDates: { value: number }[],
) => {
  // Check if it's a valid relative date value
  const num = Number(dateStr)
  if (!Number.isNaN(num)) {
    const validRelativeValues = relativeDates.map(item => item.value)
    return validRelativeValues.includes(num)
  }

  // Check if it's a valid date string (YYYY-MM-DD)
  const dateRegex = /^\d{4}-\d{2}-\d{2}$/
  if (!dateRegex.test(dateStr)) {
    return false
  }

  const date = new Date(dateStr)
  return date instanceof Date && !Number.isNaN(date.getTime())
}

export const isValidTypeParam = (
  value: string | null,
): value is SmartSearchEntityType => {
  return (
    value !== null &&
    Object.values(SmartSearchEntityType).includes(
      value as SmartSearchEntityType,
    )
  )
}

export const isValidViewParam = (
  value: string | null,
): value is SmartSearchTabsType => {
  return (
    value !== null &&
    Object.values(SmartSearchTabs).includes(value as SmartSearchTabsType)
  )
}
